<template>
    <div class="pa-3 pl-5 dialog-border white mt-3 ml-3 pb-5" >
        <div class="v-flex">
            <div style="width: calc(100% - 160px);">
                <f-read-only-field
                    style="margin-top: 14px"
                    v-if= "filter.mycustomers"
                    value ="Emails an meine Kunden"
                    filled
                    dense
                />
                <f-enum-autocomplete
                   v-if= "!filter.mycustomers"
                    v-model   = "filter.customer"
                    label     = "Kunden"
                    module    = "msd"
                    type      = "limCustomer"
                    @input = "onChange"
                    :hide-details = "true"
                />
            </div>
            <div class="pl-3" style="width: 155px">
                <v-switch
                    v-model="filter.mycustomers"
                    label="meine Kunden"
                    :ripple = "false"
                    hide-details
                    @change = "onChange"
                />
            </div>
        </div>

        <div class="v-flex mt-1 mb-2"  >
            <div class="pr-4" style="width: 110px;">
                <f-date-picker
                    label = "Von"
                    v-model="filter.from"
                    @change = "onChange"
                    :hide-details = "true"
                />

            </div>
            <div class="pr-4" style="width: 110px;">
                <f-date-picker
                    label = "Bis"
                    v-model="filter.to"
                    @change = "onChange"
                    :hide-details = "true"
                />
            </div>
            <div style="width: calc(100% - 320px);">
                <v-select
                    v-if="steps"
                    :items="steps"
                    item-value="id"
                    item-text="name"
                    label="Bearbeitungsschritt"
                    return-object
                    v-model="filter.step"
                    :hide-details = "true"
                    @change       = "onStep"
                />
            </div>
            <div class="pl-3" style="width: 185px">
                <v-switch
                    v-model = "filter.mymails"
                    class   = "mt-4"
                    label   = "meine Mails"
                    :ripple = "false"
                    @change = "onChange"
                    hide-details
                />
            </div>
        </div>
        <div>
            <v-text-field
                class="pt-2 mb-2"
                v-model = filter.text
                :hide-details = "true"
                @input        = "onSearch"
            >
                <template v-slot:append>
                    <v-icon size="20" class="ml-2" style="margin-top: 2px">mdi-magnify</v-icon>
                </template>
            </v-text-field>
        </div>

        <v-progress-linear
            v-if="loading"
            color  = "primary"
            height = "4"
            indeterminate
        />
        <div style="height: 4px;" v-if="!loading">

        </div>
    </div>

</template>

<script>
import FDatePicker from "@/modules/core/components/utils/FDatePicker.vue";
import Core from "@/modules/core/service/Core";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import FEnumAutocomplete from "@/modules/core/components/utils/FEnumAutocomplete.vue";

export default {
    name: "PIncOutboxFilter",
    components: {
        FEnumAutocomplete,
        FReadOnlyField,
        FDatePicker
    },

    props: {
        loading: {

        },

        steps: {

        }
    },

    data: () => ({
        filter: {
            customerIds: [],
            customer   : null,
            mycustomers: true,
            mymails: false,
            step: 0,
            from: null,
            to  : null,
            text: null,
        }
    }),

    computed: {
        preferences() {
            return this.$store.getters.preferences;
        },

        myCustomers () {
            return this.preferences.customer;
        },

        customerIds () {
            return this.myCustomers.map (c => c.id);
        }
    },

    mounted () {
        this.filter.from = Core.format.date.before(1);
        this.filter.to   = Core.format.date.today();

        setTimeout(() => {
            this.onChange();
        }, 500)
    },

    methods: {
        onChange () {
            if (this.filter.mycustomers) {
                this.filter.customerIds = this.customerIds
            } else if (this.filter.customer) {
                this.filter.customerIds = [ this.filter.customer.id ]
            } else {
                this.filter.customerIds = [  ]
            }

            this.$emit("filter", this.filter);
        },

        onStep () {
            this.$emit("step", this.filter.step);
        },

        onSearch () {
            this.$emit("search", this.filter.text);
        }
    }
}
</script>

<style scoped>

</style>